import React from 'react'
import SeeAll from '../../components /LandingPage/SeeAll'

const SeeAllPage = () => {
  return (
    <div>
      <SeeAll />
    </div>
  )
}

export default SeeAllPage
